<script lang="ts" setup>
import useStore from "@src/stores/store";
import {useMessageStore} from "@src/stores/messages";
import OptionScheduleMessage
    from "@src/components/views/HomeView/MainArea/FooterArea/OptionsSelector/OptionScheduleMessage.vue";
import OptionSuggestionMessage
    from "@src/components/views/HomeView/MainArea/FooterArea/OptionsSelector/OptionSuggestionMessage.vue";

import {ref} from "vue";
import {useChatSessionStore} from "@src/stores/chatSession";
import OptionCommentsModal
    from "@src/components/views/HomeView/MainArea/FooterArea/OptionsSelector/OptionCommentsModal.vue";

const openScheduleMessageModal = ref<boolean>(false);
const openSuggestionMessage = ref<boolean>(false);
const openTemplatesMessage = ref<boolean>(false);
const openCommentsModal = ref<boolean>(false)

const sessionStore = useChatSessionStore()

const props = defineProps(['icon', 'text', 'color', 'value'])
const store = useStore();
const messageStore = useMessageStore();

const selectOption = () => {
    if (props.value === 'schedule') {
        openScheduleMessageModal.value = true;
    }
    if (props.value === 'suggestions') {
        openSuggestionMessage.value = true;
    }
    if (props.value === 'comments') {
        openCommentsModal.value = true;
    }
    if (props.value === 'templates') {
        messageStore.messageTemplatesModal = true
        sessionStore.openOptionsSelector = false
    }
}

</script>

<template>
    <div
        class="option-item flex items-center justify-start gap-3 mb-3 cursor-pointer"
        @click="selectOption"
    >
        <button
            :class="props.color"
            class="p-0 w-7 h-7 rounded-full cursor-pointer shadow-lg transition ease-in duration-200 focus:outline-none flex items-center justify-center active:shadow-lg">
            <component :is="props.icon" class="w-5 h-5 text-white"/>
        </button>
        <div
            :class="store.settings.darkMode ? 'hover:bg-gray-100 text-white' : 'hover:bg-gray-100'"
            class="bg-gray-100 shadow-lg rounded-lg px-4 py-2 text-sm font-medium dark:bg-gray-700 text-gray-700 whitespace-nowrap  transition-all duration-200">
            {{ props.text }}
        </div>
        <Teleport to="#modal-root">
            <Transition
                v-if="props.value === 'schedule' && openScheduleMessageModal"
                enter-active-class="transition-all duration-300 ease-out"
                enter-from-class="opacity-0 translate-y-2"
                enter-to-class="opacity-100 translate-y-0"
                leave-active-class="transition-all duration-200 ease-in"
                leave-from-class="opacity-100 translate-y-0"
                leave-to-class="opacity-0 translate-y-2">
                <OptionScheduleMessage @closeModal="openScheduleMessageModal = false"/>
            </Transition>
        </teleport>

        <Teleport to="#modal-root">
            <Transition
                v-if="props.value === 'suggestions' && openSuggestionMessage"
                enter-active-class="transition-all duration-300 ease-out"
                enter-from-class="opacity-0 translate-y-2"
                enter-to-class="opacity-100 translate-y-0"
                leave-active-class="transition-all duration-200 ease-in"
                leave-from-class="opacity-100 translate-y-0"
                leave-to-class="opacity-0 translate-y-2">
                <OptionSuggestionMessage @closeModal="openSuggestionMessage = false"/>
            </Transition>
        </teleport>
        <Teleport to="#modal-root">
            <Transition
                v-if="openCommentsModal"
                enter-active-class="transition-all duration-300 ease-out"
                enter-from-class="opacity-0 translate-y-2"
                enter-to-class="opacity-100 translate-y-0"
                leave-active-class="transition-all duration-200 ease-in"
                leave-from-class="opacity-100 translate-y-0"
                leave-to-class="opacity-0 translate-y-2">
                <OptionCommentsModal @closeModal="openCommentsModal = false"/>
            </Transition>
        </teleport>
    </div>
</template>

<style scoped>
.option-item {
    transition: all 0.3s ease;
}

.option-item:hover {
    transform: translateX(-5px);
}

.option-item:hover > div {
    transform: scale(1.05);
}

.option-item:hover > button {
    transform: scale(1.1);
}

.option-item > div,
.option-item > button {
    transition: transform 0.2s ease;
}
</style>